import { Injectable } from "@angular/core";
import { IID_OL_CONDOMINIO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolCondominioStore } from "./iidOlCondominio.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.CONDOMINIO)
export class IIDolCondominioQuery extends AbstractInterfaceDataQuery<IID_OL_CONDOMINIO> {

  constructor(protected store: IIDolCondominioStore) {
    super(store);
  }
}
